import styled from 'styled-components'

const ComponentStyled = styled.div`
  .select-seed-box {
    max-width: 600px;
    margin: 0 auto;

    .select-seed-content {
      background-color: ${({ theme }) => theme.colors.secondaries.opacity30};
      padding: 50px 24px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .seed-wrapper {
        display: flex;
        align-items: center;
        border-radius: 8px;
        transition: 0.5s ease all;
        cursor: pointer;
        padding: 24px;
        position: relative;

        .check {
          position: absolute;
          right: 24px;
        }

        &:hover {
          background-color: ${({ theme }) => theme.colors.secondaries.opacity60};
        }

        &.selected {
          background-color: ${({ theme }) => theme.colors.secondaries.opacity10};
        }

        .seed-content {
          margin-left: 24px;
          padding-right: 50px;

          .seed-name {
            font-family: 'Playfair Display';
            font-weight: 900;
            font-size: 28px;
            line-height: 28px;
            letter-spacing: -0.02em;
            color: ${({ theme }) => theme.colors.pureBlack};
            margin-bottom: 5px;
          }

          .seed-desc {
            font-family: 'Cabin';
            font-weight: 400;
            font-size: 16px;
            line-height: 18px;
            letter-spacing: 0.02em;
            color: ${({ theme }) => theme.colors.black};
          }
        }
      }

      .next-btn-wrapper {
        margin-top: 40px;
        text-align: center;
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    .select-seed-box {
      max-width: 600px;
      margin: 0 auto;

      .select-seed-content {
        padding: 50px 24px;

        .seed-wrapper {
          .seed-content {
            .seed-name {
              font-size: 20px;
              line-height: 20px;
            }

            .seed-desc {
              font-size: 14px;
              line-height: 17px;
            }
          }
        }
      }
    }
  }
`

export default ComponentStyled
